export interface HistoryItem {
  id: number;
  dealerCode: string | undefined;
  resultType: string | undefined;
  pageType: string | undefined;
  description: string | undefined;
  start: string | undefined;
  end: string | undefined;
}

export interface HistoryDetailItem {
  id: number;
  resultType: string | undefined;
  vin: string | undefined;
  lcdv: string | undefined;
  jobNo: string | undefined;
  rowNumber: string | undefined;
  details: string | undefined;
}

export interface HistoryDetailListResponse {
  count: number;
  historyDetails: HistoryDetailItem[];
}

export enum PageType {
  BULK = 'BULK',
  VIN = 'VIN',
}
